export { BaseIcon, CloneIcon } from './BaseIcon';
export { IconColor, IconSize } from './BaseIcon.types';
export type { BaseIconProps } from './BaseIcon.types';
